import "../../init";

import KikoffCardContainer from "@component/landing/kikoff_card/container";

function KikoffCardLandingPage() {
  return <KikoffCardContainer flow="signup" />;
}

export default KikoffCardLandingPage;
